/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './IoTImageMapper';

const IoTImageMapperManager: ComponentManagerFn<'IoTImageMapper'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'IoTImageMapper'>(platform, 'IoTImageMapper'),
    type: 'IoTImageMapper',
    name: 'IoT Image Mapper',
    isChildAllowed: (page, item, childType, { appUid, pageId }) => {
      if (
        !(
          [
            'Area',
            // 'Device',
            'ExpressionWatchListener',
            // 'Popover',
            // 'Pulse',
            'PulseTip',
            // 'Tracker',
            'AreaToolbar',
          ] as ItemType[]
        ).includes(childType)
      ) {
        return false;
      }
      if (
        (
          ['Area', 'Device', 'Popover', 'Pulse', 'Tracker'] as ItemType[]
        ).includes(childType)
      ) {
        const children = platform.getChildrenOfType(
          appUid,
          pageId,
          page,
          item,
          childType,
        );
        return children.length === 0 ? true : 'Already added';
      }
      return true;
    },
    defaultValue,
    props: {
      imageSrc: {
        label: 'Image Src',
        type: 'expressionOnly',
        returnType: () => 'string',
      },
      imageWidth: {
        label: 'Image Width',
        type: 'expressionOnly',
        returnType: () => 'number',
      },
      imageHeight: {
        label: 'Image Height',
        type: 'expressionOnly',
        returnType: () => 'number',
      },
      scale: {
        label: 'Initial Zoom Level',
        type: 'number',
        min: 0.1,
        max: 20,
        step: 0.1,
      },
      usePublicUrl: {
        label: 'Use Public URL',
        type: 'boolean',
        helpText:
          'When using Attachment File Id, check this to use a public URL instead of authenticated URL to allow browser to cache the image. The dataSource must have "Public Download Allowed" access checked for public role.',
      },
      updatable: {
        label: 'Updatable',
        type: 'booleanExpression',
      },
      hideZoomButtons: {
        label: 'Hide Zoom Buttons',
        type: 'boolean',
      },
      hideZoomLevel: {
        label: 'Hide Zoom Level Indicator',
        type: 'boolean',
      },
      doubleClickToZoom: {
        label: 'Double Click To Zoom',
        type: 'boolean',
      },
    },
    isPropertyVisible: (property, itemData) => {
      switch (property) {
        case 'hideZoomLevel':
          return !itemData.hideZoomButtons;
        default:
          return true;
      }
    },
    canHaveChildren: () => true,
    category: 'IoT',
    icon: { iconName: 'draw-polygon' },
    description: 'IoT Image Mapper',
  };
};

export default IoTImageMapperManager;
